export default __webpack_public_path__ + "static/media/provesional_restoration_upper_24_4@2x.c964a389.png";